export default function InquirySection() {
  return (
    <section
      id="inquiry"
      className="bg-studio-dark py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="w-full max-w-4xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="text-studio-gray/30 font-bebas text-[clamp(60px,10vw,140px)] leading-none block">
            07
          </span>
          <h2
            className="text-white font-bebas uppercase leading-none -mt-6 md:-mt-12"
            style={{ fontSize: 'clamp(40px, 6vw, 80px)', lineHeight: 1 }}
          >
            상담 신청
          </h2>
          <p className="text-studio-gray font-sans text-lg md:text-xl mt-4">
            아래 채널 중 편하신 곳으로 문의해주세요
          </p>
        </div>

        <div className="bg-studio-card border border-studio-border rounded-lg p-12 md:p-16 text-center">
          <p className="text-studio-silver font-sans text-lg md:text-xl mb-10">
            카카오톡 또는 네이버 톡톡으로 상담을 신청해주시면
            <br className="hidden sm:block" />
            빠르게 답변드리겠습니다.
          </p>

          <div className="flex items-center justify-center gap-4 md:gap-6 flex-wrap">
            <a
              href="https://pf.kakao.com/_phLXb/92161526"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#FEE500] text-[#191919] font-sans font-bold text-base md:text-lg px-8 md:px-10 py-4 rounded-full hover:bg-[#FDD835] transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <i className="ri-kakao-talk-fill text-2xl" />
              </div>
              카카오톡 1:1 상담
            </a>
            <a
              href="https://talk.naver.com/profile/wkw9jg5"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#03C75A] text-white font-sans font-bold text-base md:text-lg px-8 md:px-10 py-4 rounded-full hover:bg-[#02A84C] transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <i className="ri-chat-smile-2-fill text-2xl" />
              </div>
              네이버 톡톡
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}